import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { GlobalsVariables } from '../global-Variables';

@Component({
  selector: 'app-impressum',
  templateUrl: './imprint.component.html',
  styleUrls: ['./imprint.component.scss']
})
export class ImprintComponent implements OnInit {

  constructor( public meta: Meta, public title: Title, private globalVari:GlobalsVariables ) { 
    let site:string="imprint";
    this.meta.updateTag({ name: 'description', content: globalVari.meta[site].description }); 
    this.title.setTitle("Chris Wehrmann - "+globalVari.meta[site].title ); 
  }

  ngOnInit() {
  }

}
